import * as actionTypes from "../action-types";

export const getCategory = payload => ({ type: actionTypes.GET_CATEGORY, payload });
export const getSubCategory = payload => ({ type: actionTypes.GET_SUB_CATEGORY, payload });
export const getDataBySubCategory = payload => ({ type: actionTypes.GET_DATA_BY_SUB_CATEGORY, payload });
export const getPodcastBySubCategory = payload => ({ type: actionTypes.GET_PODCAST_BY_SUB_CATEGORY, payload });

//! News
export const getBreakingNews = payload => ({ type: actionTypes.GET_BREAKING_NEWS, payload });
export const getNewsCategory = payload => ({ type: actionTypes.GET_NEWS_CATEGORY, payload });
export const getNewsByCategory = payload => ({ type: actionTypes.GET_NEWS_BY_CATEGORY, payload });

//! Live
export const getLiveVideo = payload => ({ type: actionTypes.GET_LIVE_VIDEO, payload });

//! Daily Darshan
export const getDailyDarshan = payload => ({ type: actionTypes.GET_DAILY_DARSHAN, payload });

//! Consultancy
export const createConsultancy = payload => ({ type: actionTypes.CREATE_CONSULTANCY, payload });